import { format, isValid, parseISO } from 'date-fns';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';


export const DEFAULT_DATE_FORMAT = 'dd-MMM-yyyy'; // TODO: use 18N format
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format an ISO date string for display (e.g. "2024-01-15" -> "15/01/2024").
 */
export const formatISOToDisplayDate = (iso: string | null | undefined, dateFormat: string = DEFAULT_DATE_FORMAT) => {
  if (!iso) return '-';
  try {
      const date = parseISO(iso);

      return isValid(date) ? format(date, dateFormat) : '-';
  } catch {
      return '-';
  }
};


// Converts a Date object to a string in 'yyyy-MM-dd' format.
// This format is used consistently throughout the application for date inputs and comparisons.
// We currently assume that dates provided in ISO format (e.g., from APIs or user input) are reliable,
// so this function helps standardize Date objects to match that format for consistency and compatibility.
export const toDateString = (date: Date | null | undefined): string => {
  if (!date || Number.isNaN(date.getTime())) {
      return '-';
  }

  return format(date, ISO_DATE_FORMAT);
};